import { Controller } from "@hotwired/stimulus"
import * as echarts from 'echarts';

// Connects to data-controller="radar-chart"
export default class extends Controller {
  static values = {
    data: Array,
    color: String,
  }

  connect() {
    if (!this.element) return;
    
    // Initialize chart
    this.chart = echarts.init(this.element);
    this.renderChart();

    // Handle resize events
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  disconnect() {
    window.removeEventListener('resize', this.handleResize.bind(this));
    if (this.chart) {
      this.chart.dispose();
    }
  }

  handleResize() {
    if (this.chart) {
      this.chart.resize();
    }
  }

  renderChart() {
    // Default color scheme if none provided
    const chartColor = this.colorValue || '#A6C34C'; // Default green color similar to the image
    
    // Parse data
    const chartData = this.hasDataValue ? this.dataValue : this.defaultData();
    
    // Get indicators for radar chart
    const indicators = chartData.map(item => ({
      name: item.name,
      max: item.max || 5
    }));
    
    // Get values in array format
    const values = chartData.map(item => item.value);
    
    // Chart options
    const option = {
      title: {
        text: this.titleValue || '',
        textStyle: {
          color: '#333',
          fontSize: 16
        },
        left: 'center'
      },
      radar: {
        indicator: indicators,
        shape: 'circle',
        splitNumber: 5,
        axisName: {
          formatter: '{value}',
          color: '#333'
        },
        splitArea: {
          areaStyle: {
            color: ['#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF'],
            shadowColor: 'rgba(255, 255, 255, 0)',
            shadowBlur: 10
          }
        },
        axisLine: {
          lineStyle: {
            color: '#999'
          }
        },
        splitLine: {
          lineStyle: {
            color: '#999'
          }
        }
      },
      series: [{
        type: 'radar',
        areaStyle: {
          color: chartColor,
          opacity: 0.6
        },
        lineStyle: {
          color: chartColor,
          width: 2
        },
        itemStyle: {
          color: chartColor
        },
        data: [{
          value: values,
          name: this.titleValue || 'Assessment'
        }]
      }]
    };
    
    this.chart.setOption(option);
  }

  defaultData() {
    // Sample data structure for the chart (placeholder data)
    return [
      { name: 'E', value: 3.5 }, 
      { name: 'S', value: 4.2 }, 
      { name: 'G', value: 2.8 }
    ];
  }
}
